module.exports = __webpack_public_path__ + "img/disable-view-docs.16a9e91a.svg";